import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../api/api';
import { useAuth } from '../context/AuthContext';
import { FaIdCard, FaSpinner } from 'react-icons/fa';

function BecomeBrokerPage() {
    const [brokerLicense, setBrokerLicense] = useState(null);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { refetchUser } = useAuth();

    const handleFileChange = (e) => {
        setBrokerLicense(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!brokerLicense) {
            setError('Broker license file is required to proceed.');
            return;
        }
        setError('');
        setLoading(true);

        const formData = new FormData();
        formData.append('broker_license', brokerLicense);

        try {
            await apiClient.post('/broker/convert-me', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            
            // Refetch user data to get new role and then navigate
            await refetchUser();
            alert('Congratulations! You are now a Broker.');
            navigate('/broker-dashboard');

        } catch (err) {
            setError(err.response?.data?.message || 'Application failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
            <div className="w-full max-w-lg bg-white rounded-lg shadow-2xl p-8">
                <h2 className="text-2xl font-bold text-gray-800 text-center mb-2">Become a Broker</h2>
                <p className="text-center text-gray-600 mb-8">Upload your broker license to unlock broker functionalities.</p>
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Broker License</label>
                        <div className="relative border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-green-500 transition-colors">
                            <input
                                type="file"
                                id="broker-license-upload"
                                onChange={handleFileChange}
                                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                accept="image/*,application/pdf"
                                required
                            />
                            <div className="flex flex-col items-center justify-center">
                                <FaIdCard className="text-gray-400 text-4xl mb-2" />
                                <span className="text-gray-600 font-medium">
                                    {brokerLicense ? brokerLicense.name : 'Click to upload your license'}
                                </span>
                                <span className="text-gray-500 text-xs mt-1">PNG, JPG or PDF (Max 2MB)</span>
                            </div>
                        </div>
                    </div>

                    {error && <p className="text-red-500 text-sm text-center">{error}</p>}

                    <div>
                        <button type="submit" className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg disabled:bg-gray-400" disabled={loading}>
                            {loading ? <span className="flex items-center justify-center"><FaSpinner className="animate-spin mr-2" /> Submitting...</span> : 'Submit & Become a Broker'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default BecomeBrokerPage;
